<template>
  <v-toolbar class="kbWhite" id="drawer-toolbar" flat>
    <v-row align="center"
           class="flex-nowrap pt-4"
           justify="space-between">
      <v-col :class="minimizedDrawer ? 'px-0 text-center': ''">
        <v-btn icon
               height="60px"
               width="60px"
               v-show="minimizedDrawer"
               @click="toggleSideBar()">
          <v-icon color="kbDarkText"
                  size="45px">
            mdi-menu
          </v-icon>
        </v-btn>
        <v-img v-show="!minimizedDrawer" :src="sideBarLogo" :width="isCloudTask ? '90' : '66'" />
      </v-col>

      <v-col class="shrink" v-show="openedDrawer && !minimizedDrawer">
        <CompanyAppList v-if="$vuetify.breakpoint.smAndDown"/>
      </v-col>

      <v-btn icon
             style="position: absolute;
                    right: 0;
                    top: 15px;
                    transform: rotate(-90deg);
                    font-weight: 300!important;
                    padding-bottom: 12px;"
             @click="toggleSideBar()"
             v-show="!minimizedDrawer && $vuetify.breakpoint.mdAndUp">
        <v-icon size="28px" color="kbDarkText">feather-bar-chart-2</v-icon>
      </v-btn>
    </v-row>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import CompanyAppList from '@/components/widgets/list/CompanyAppList.vue'
export default {
  components: {
    CompanyAppList
  },
  computed: {
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask
    }),
    sideBarLogo () {
      if (this.isCloudTask) return 'https://storage.googleapis.com/keybe/cloudtask/cloudtask-logo.svg'
      if (this.$vuetify.theme.isDark) return 'https://storage.googleapis.com/keybe/images/kb-logos/kb-white2.png'
      return 'https://storage.googleapis.com/keybe/images/kb-logos/keybe-light.svg'
    }
  },
  methods: {
    toggleSideBar () {
      this.$emit('toggleSideBar')
    }
  },
  props: {
    minimizedDrawer: {
      type: Boolean,
      required: true
    },
    openedDrawer: {
      type: Boolean,
      required: true
    }
  }
}
</script>
